

import './index.css';
import { About } from './about/About';
import { Contact } from './contact/Contact';
import { Navbar } from './nav/Navbar';
import { Projects } from './projects/Projects';
import { Skills } from './skills/Skills';
import { Footer } from './footer/Footer';
import styled from 'styled-components';
import { GitCalender } from './git-calender/GitCalender';

function App() {
  return (
    <div>
      {/* <First_Blurd></First_Blurd>
      <Second_Blurd></Second_Blurd> */}
      <Navbar/>
     <WRAPPER>
      <About/>
      <GitCalender/>
      <Skills/>
      <Projects/>
      <Contact/>
      <Footer/>
      
     </WRAPPER>
    </div>
  );
}
const WRAPPER = styled.div`
 padding: 3rem 0 0 0;
`
// const MainWrapper = styled.div`
//  background-color: #DDFFF9;
// `
// const First_Blurd = styled.div`
// background-color: red;
// position: fixed;
// width: 10rem;
// height: 15rem;
// filter: blur(9rem)
// `
// const Second_Blurd = styled.div`
//  background-color: blue;
//  width: 15rem;
// `

export default App;
